import { authenticatedInstance } from '../index/index.service';
import { extractServiceErrorMessage } from '../shared/service-error.util';
import type {
  AdminTransferAuditPage,
  AdminTransferAuditQuery,
  AdminTransferAuditView,
} from 'shared-models/browser';

export type {
  AdminTransferAuditPage,
  AdminTransferAuditQuery,
  AdminTransferAuditView,
  AdminTransferKind,
  AdminTransferOrderlineSnapshot,
} from 'shared-models/browser';

class AdminTransferAuditService {
  async list(query: AdminTransferAuditQuery = {}): Promise<AdminTransferAuditPage> {
    try {
      const response = await authenticatedInstance.get<AdminTransferAuditPage>('/payments/admin/table-movements', {
        params: query,
      });
      return response.data;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, ''));
    }
  }

  async getDetail(id: number): Promise<AdminTransferAuditView> {
    try {
      const response = await authenticatedInstance.get<AdminTransferAuditView>(`/payments/admin/table-movements/${id}`);
      return response.data;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, ''));
    }
  }
}

export const adminTransferAuditService = new AdminTransferAuditService();
